export class Settings {
  public static URL_FORMS = 'https://forms.office.com/Pages/ResponsePage.aspx?id=VLRKuCHj_UOD19Ay8HbrsguLnN5M-I5EiBoQi6dKKxxUNlFQWjI0MENPWEw3UzZaQlhTOFlTME1PWi4u';

  constructor() {
  }
}
